import { FC } from 'react';
import { ArrowRightIcon } from 'assets/icons';
import TransactionCardV2 from './TransactionCardV2';
import { TransactionV2 } from '../invoices.model';

interface TransactionsListProps {
  transactions: TransactionV2[];
  invoiceNumber: string;
  onBack: () => void;
  onTxnClick: (id: string, status?: string) => void;
  onDisputeClick: (id: string) => void;
  onRefundClick: (id: string) => void;
}

const TransactionsList: FC<TransactionsListProps> = ({
  transactions,
  invoiceNumber,
  onBack,
  onTxnClick,
  onDisputeClick,
  onRefundClick
}) => {
  return (
    <div className="flex h-full w-96 max-w-sm flex-col bg-[#F7F7F7]">
      <div className="flex items-center gap-2 border-b border-borderGray bg-white py-3 px-4">
        <div onClick={onBack} className="cursor-pointer">
          <ArrowRightIcon className="path-fill-current rotate-180 text-primaryText" id="transactions-list-back-arrow" />
        </div>
        <div id="transactions-list-head" className="text-17px font-semibold text-headingGray">
          Transactions - {invoiceNumber}
        </div>
      </div>
      <div className="customNormalScroll flex max-w-sm grow flex-col gap-0 overflow-y-auto overflow-x-hidden">
        <div className="grow bg-white">
          <div className="divide-y divide-secondaryBtn px-4 py-3">
            {transactions?.map(transaction => (
              <TransactionCardV2
                key={transaction.transactionId}
                transaction={transaction}
                onTxnClick={onTxnClick}
                onDisputeClick={onDisputeClick}
                onRefundClick={onRefundClick}
                shouldCheckPermission={true}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionsList;
